import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import Button from '../../Input/Button/Button';

import './CommonBox.scss';

export default class CommonBox extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * title
         */
        title: PropTypes.string,
        /**
         * description
         */
        description: PropTypes.string,
        /**
         * svg icon. ex) <svg xmlns="http://www.w3.org/2000/svg" width="37" height="38" viewBox="0 />
         */
        svg: PropTypes.node,
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        title: '',
        description: '',
        svg: null,
        children: null,
        className: '',
    };

    render() {
        const { className, svg, title, description, children } = this.props;
        const cn = `component-LeftRail-CommonBox ${className}`.trim();
        return (
            <div className={cn}>
                {svg && <div className="image">{svg}</div>}
                {title && <div className="title">{title}</div>}
                {description && (
                    <div className="description">{description}</div>
                )}
                {children && <div className="children">{children}</div>}
            </div>
        );
    }
}

const executeMetricAndOnClick = (metric, onClick) => {
    if (metric) EmitMetric(metric);
    onClick();
};

export const LeftRailButton = ({
    text,
    onClick,
    metric,
    className = 'primary-btn',
}) => {
    let cn = `base-btn text-orchid-dk hover-bg-gray hover-text-rockblue ${className}`.trim();

    if (className.indexOf('profileCardBtn') !== -1) {
        cn = `base-btn text-orchid-dk ${className}`.trim();
    }

    return (
        <Button
            className="btn-wrapper"
            inputStyle={cn}
            onClick={() => executeMetricAndOnClick(metric, onClick)}
            value={text}
        />
    );
};

LeftRailButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    metric: PropTypes.object,
    className: PropTypes.string,
};

LeftRailButton.defaultProps = {
    onClick: () => {},
    metric: null,
    className: 'primary-btn',
};

export const PurpleButton = ({
    value,
    onClick = () => {},
    metric = null,
    className = 'btn-wrapper',
    inputStyle = 'btn-style',
}) => {
    return value ? (
        <Button
            type="purple-medium-white"
            class={className}
            inputStyle={inputStyle}
            onClick={() => executeMetricAndOnClick(metric, onClick)}
            value={value}
        />
    ) : null;
};
